import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth, type Role } from '@/lib/auth';
import { Loading } from './ui';

export function RequireAuth() {
  const { session, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <Loading />;
  if (!session) return <Navigate to="/signin" state={{ from: loc.pathname + loc.search }} replace />;
  return <Outlet />;
}

export function RequireRole({ roles }: { roles: Role[] }) {
  const { loading, roles: mine, hasRole } = useAuth();
  if (loading) return <Loading />;
  if (mine.length === 0) return <NoRole />;
  if (!hasRole(...roles)) return <div className="page"><h1>Not allowed</h1><p>This page needs one of: {roles.join(', ')}.</p></div>;
  return <Outlet />;
}

export function NoRole() {
  const { me, signOut } = useAuth();
  return (
    <div className="page narrow">
      <h1>No access yet</h1>
      <p>You are signed in as <b>{me?.email}</b>, but no role has been given to this email. Ask an admin to add you under Settings → Users.</p>
      <button type="button" className="btn" onClick={signOut}>Sign out</button>
    </div>
  );
}
